import { render, staticRenderFns } from "./MaterialStatsCard.vue?vue&type=template&id=6893a816&scoped=true"
import script from "./MaterialStatsCard.vue?vue&type=script&lang=js"
export * from "./MaterialStatsCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialStatsCard.vue?vue&type=style&index=0&id=6893a816&prod&lang=sass"
import style1 from "./MaterialStatsCard.vue?vue&type=style&index=1&id=6893a816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893a816",
  null
  
)

export default component.exports